const STORAGE_URL = process.env.REACT_APP_STORAGE_URL;

const getStorageImage = (path: string, container: string) => {
  const params = new URLSearchParams({ path, container });

  return `${STORAGE_URL}?${params}`;
};

export { getStorageImage };
